import React from 'react';
import { Fab, Tooltip, Zoom, useScrollTrigger } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { isSandbox } from '../../../utils/environment';
import { BAR_HEIGHT } from './sandbox-bar';

/** Botão flutuante (canto inferior direito) que aparece depois de rolar a página e volta ao topo. */
export default function BackToTopButton({ threshold = 400 }: { threshold?: number }) {
  const visible = useScrollTrigger({ disableHysteresis: true, threshold });
  // No sandbox a faixa fixa ocupa o rodapé da tela; o botão fica acima dela
  const offset = isSandbox() ? BAR_HEIGHT : 0;

  const scrollToTop = () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  };

  return (
    <Zoom in={visible}>
      <Tooltip title="Voltar ao topo" placement="left">
        <Fab
          color="primary"
          size="medium"
          aria-label="Voltar ao topo"
          onClick={scrollToTop}
          sx={{
            position: 'fixed',
            right: { xs: 16, md: 32 },
            bottom: { xs: 16 + offset, md: 32 + offset },
            zIndex: (theme) => theme.zIndex.speedDial,
          }}
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </Tooltip>
    </Zoom>
  );
}
